import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConfigureStore } from "./_redux/configureStore";
import "../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./index.scss";
import App from "./App";

ReactDOM.render(
  <Provider store={ConfigureStore()}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById("root")
);
